import React from 'react';
import { UserChip } from '../shared/chips/UserChip';
import { BrokerGroupChip } from '../shared/chips/BrokerGroupChip';
import { LedgerChip } from '../shared/chips/LedgerChip';

const CHIPS_BY_FIELD = {
	users: UserChip,
	brokerGroups: BrokerGroupChip,
	ledgers: LedgerChip,
};

/**
 * One of a feature flag's users, broker groups or ledgers (`field`) as a chip, looked up by
 * `id`: users show their avatar and name, broker groups their name, ledgers as they are.
 * User chips also take showEmail, to show the user's email on hover; only pass it for
 * users. Other props go to the MUI Chip.
 */
export const FeatureFlagTargetChip = ({ field, ...props }) => {
	const TargetChip = CHIPS_BY_FIELD[field];
	return <TargetChip {...props} />;
};
